class CalloutBanner extends HTMLElement {
  constructor() {
    super();
    this.mobileBehavior = this.dataset.mobileBehavior;
    this.animationDelay = parseFloat(this.dataset.animationDelay) * 1000;
    this.currentIndex = 0;
    this.animationTimer = null;
    this.isAnimating = false;
    
    this.callouts = Array.from(this.querySelectorAll('.callout-banner__item'));
    this.totalCallouts = this.callouts.length;
    
    if (this.totalCallouts === 0) return;
    
    this.init();
  }

  init() {
    // Apply mobile behavior on load and resize
    this.applyMobileBehavior();
    
    // Add resize listener with debounce
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.applyMobileBehavior();
      }, 250);
    });
  }

  applyMobileBehavior() {
    const isMobile = window.innerWidth < 750;
    
    // Clear any existing animation
    if (this.animationTimer) {
      clearTimeout(this.animationTimer);
      this.animationTimer = null;
    }
    
    // Reset all callouts to visible state
    this.callouts.forEach((callout) => {
      callout.classList.remove('is-hidden', 'is-scaled-out', 'is-scaled-in');
      callout.style.display = '';
    });
    
    if (!isMobile) {
      // Desktop: show all callouts
      return;
    }
    
    // Mobile behaviors
    switch (this.mobileBehavior) {
      case 'single':
        this.showSingleCallout();
        break;
      case 'animated':
        this.startAnimatedRotation();
        break;
      case 'stack':
      default:
        // Stack mode: all callouts visible (default behavior)
        break;
    }
  }

  showSingleCallout() {
    // Show only the first callout
    this.callouts.forEach((callout, index) => {
      if (index === 0) {
        callout.style.display = '';
      } else {
        callout.style.display = 'none';
      }
    });
  }

  startAnimatedRotation() {
    if (this.totalCallouts <= 1) {
      return; // No need to animate if only one callout
    }
    
    // Initially show only the first callout
    this.currentIndex = 0;
    this.callouts.forEach((callout, index) => {
      if (index === 0) {
        callout.classList.add('is-scaled-in');
      } else {
        callout.classList.add('is-scaled-out');
      }
    });
    
    // Start the rotation
    this.scheduleNextAnimation();
  }

  scheduleNextAnimation() {
    this.animationTimer = setTimeout(() => {
      this.animateToNext();
    }, this.animationDelay);
  }

  animateToNext() {
    if (this.isAnimating) return;
    
    const isMobile = window.innerWidth < 750;
    if (!isMobile || this.mobileBehavior !== 'animated') {
      return; // Stop if no longer in mobile animated mode
    }
    
    this.isAnimating = true;
    
    const currentCallout = this.callouts[this.currentIndex];
    const nextIndex = (this.currentIndex + 1) % this.totalCallouts;
    const nextCallout = this.callouts[nextIndex];
    
    // Scale out current
    currentCallout.classList.remove('is-scaled-in');
    currentCallout.classList.add('is-scaled-out');
    
    // Small delay, then scale in next
    setTimeout(() => {
      nextCallout.classList.remove('is-scaled-out');
      nextCallout.classList.add('is-scaled-in');
      
      this.currentIndex = nextIndex;
      this.isAnimating = false;
      
      // Schedule next animation
      this.scheduleNextAnimation();
    }, 300);
  }

  disconnectedCallback() {
    if (this.animationTimer) {
      clearTimeout(this.animationTimer);
    }
  }
}

if (typeof customElements.get('callout-banner') === 'undefined') {
  customElements.define('callout-banner', CalloutBanner);
}
